const GlobeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="inherit"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.75 12c0 5.661 4.589 10.25 10.25 10.25S22.25 17.661 22.25 12c0-5.655-4.579-10.24-10.231-10.25h-.038C6.329 1.76 1.75 6.345 1.75 12Zm7.262-.75c.072-2.248.461-4.24 1.034-5.692.319-.808.68-1.411 1.043-1.8.357-.382.662-.505.902-.508h.02c.24.003.545.126.902.508.363.389.724.992 1.043 1.8.573 1.452.963 3.444 1.034 5.692H9.012Zm5.976 1.5c-.072 2.248-.461 4.24-1.034 5.692-.319.808-.68 1.411-1.043 1.8-.362.387-.67.508-.911.508s-.55-.121-.911-.508c-.363-.389-.724-.992-1.043-1.8-.573-1.452-.963-3.444-1.034-5.692h5.976Zm1.501 0h4.23a8.756 8.756 0 0 1-6.015 7.574c.24-.4.455-.848.646-1.331.654-1.656 1.067-3.842 1.139-6.243Zm4.229-1.5h-4.23c-.072-2.4-.486-4.587-1.14-6.243a9.193 9.193 0 0 0-.645-1.331 8.759 8.759 0 0 1 6.015 7.574Zm-13.207 0H3.282a8.757 8.757 0 0 1 6.014-7.574c-.24.4-.455.848-.645 1.331-.654 1.656-1.068 3.842-1.14 6.243Zm0 1.5c.072 2.4.486 4.587 1.14 6.243.191.483.406.931.646 1.331a8.758 8.758 0 0 1-6.015-7.574h4.229Z" />
    </svg>
  );
};

export default GlobeIcon;
